// Header menu hover @ < 1200
if (window.innerWidth >= 1200) {
	const menuWithChildren = document.querySelectorAll('.menu-link__children');
	menuWithChildren.forEach((menuParent) => {
		menuParent.addEventListener('mouseenter', (evt) => {
			evt.currentTarget.classList.add('menu-active');
		});
		menuParent.addEventListener('mouseleave', (evt) => {
			evt.currentTarget.classList.remove('menu-active');
		});
	});

	const menuWithGChildren = document.querySelectorAll('.menu-link__grandchildren');
	menuWithGChildren.forEach((menuGrandparent) => {
		menuGrandparent.addEventListener('mouseenter', (evt) => {
			evt.currentTarget.classList.add('grandchild-menu-active');
		});
		menuGrandparent.addEventListener('mouseleave', (evt) => {
			evt.currentTarget.classList.remove('grandchild-menu-active');
		});
	});
}

// Header menu click @ < 1999
if (window.innerWidth <= 1999) {
	const menuWithChildren = document.querySelectorAll('.menu-link__children');
	menuWithChildren.forEach((menuParent) => {
		menuParent.querySelector('i').addEventListener('click', (evt) => {
			evt.currentTarget.parentElement.classList.toggle('menu-active');
		});
	});

	const menuWithGChildren = document.querySelectorAll('.menu-link__grandchildren');
	menuWithGChildren.forEach((menuGrandparent) => {
		menuGrandparent.querySelector('i').addEventListener('click', (evt) => {
			evt.currentTarget.parentElement.classList.toggle('menu-active');
		});
	});
}

// Offers in sub menus (hard-coded)
if (document.querySelector('.menu-link__for-car')) {
	const carsOfferTitle = document.querySelector('.menu-link__for-car h3');
	const carsOfferSub = document.querySelector('.menu-link__for-car p');
	carsOfferTitle.innerHTML += 'Subscribe';
	carsOfferSub.innerHTML += 'Save and';
	document.querySelector('.menu-link__for-car .dropdown-child__offer').addEventListener('click', (event) => {
		window.location.href = '/subscriptions';
	});
}

if (document.querySelector('.menu-link__for-home')) {
	const homesOfferTitle = document.querySelector('.menu-link__for-home h3');
	const homesOfferSub = document.querySelector('.menu-link__for-home p');
	homesOfferTitle.innerHTML += 'Carfume Home Club';
	homesOfferSub.innerHTML += 'Join The';
}

// Reviews slider
const swiperReviews = new Swiper('.reviews__slider', {
	slidesPerView: 1,
	loop: false,
	spaceBetween: 0,
	breakpoints: {
		767: {
			slidesPerView: 2,
			spaceBetween: 50,
		},
	},

	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});

// Product media list
// const productMediaList = new Swiper(".product__media-list", {
//   slidesPerView: 1,
//   loop: false,
//   spaceBetween: 0,
// });

// Collections sliders forEach
document.querySelectorAll('.collections-module').forEach(function (collectionsSlider) {
	new Swiper(collectionsSlider.querySelector('.collections__wrapper'), {
		slidesPerView: 1,
		spaceBetween: 30,
		loop: true,
		breakpoints: {
			575: {
				slidesPerView: 2,
			},
			767: {
				slidesPerView: 3,
			},
			1200: {
				slidesPerView: 4,
			},
		},

		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});
});

// Tablet > slider
var init = false;
function swiperUsp() {
	if (window.innerWidth <= 767) {
		if (!init) {
			init = true;
			swiper = new Swiper('.usp-bar__wrapper', {
				direction: 'horizontal',
				slidesPerView: '1',
				centeredSlides: true,
				spaceBetween: 32,
				autoplay: {
					delay: 5000,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		}
	} else if (init) {
		swiper.destroy();
		init = false;
	}
}
swiperUsp();
window.addEventListener('resize', swiperUsp);

// Tablet > slider @logos
var init2 = false;
function swiperLogos() {
	if (window.innerWidth <= 767) {
		if (!init2) {
			init2 = true;
			swiper = new Swiper('.logos__wrapper', {
				direction: 'horizontal',
				slidesPerView: '1',
				centeredSlides: true,
				spaceBetween: 32,
				autoplay: {
					delay: 5000,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		}
	} else if (init2) {
		swiper.destroy();
		init2 = false;
	}
}
swiperLogos();
window.addEventListener('resize', swiperLogos);

// Tablet > slider @footer_logos
var init3 = false;
function footerLogos() {
	if (window.innerWidth <= 767) {
		if (!init3) {
			init3 = true;
			swiper = new Swiper('.footer__logos-wrapper', {
				direction: 'horizontal',
				slidesPerView: '1',
				centeredSlides: true,
				spaceBetween: 32,
				autoplay: {
					delay: 5000,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		}
	} else if (init3) {
		swiper.destroy();
		init3 = false;
	}
}
footerLogos();
window.addEventListener('resize', footerLogos);

// Mobile menu
const menuOpen = document.querySelector('.header__menu-open');
const menuClose = document.querySelector('.header__menu-close');
const body = document.querySelector('body');

menuOpen.addEventListener('click', () => {
	body.classList.add('menu-open', 'overflow-hidden');
});

menuClose.addEventListener('click', () => {
	body.classList.remove('menu-open', 'overflow-hidden');
});

if (document.querySelector('.main-product')) {
	const dropdown = document.getElementById('product-select');
	const divs = document.querySelectorAll('.main-product__variant-description');

    if (dropdown) {
      dropdown.addEventListener('change', (event) => {
		const selectedOption = dropdown.options[dropdown.selectedIndex];
		const dataName = selectedOption.getAttribute('data-name');
		divs.forEach((div) => {
			if (div.getAttribute('data-name') === dataName) {
				div.classList.add('active');
			} else {
				div.classList.remove('active');
			}
		});
	});
      
    }
}

if (document.querySelector('.module-collection')) {
	const selectElement = document.querySelector('.sort-by-box-okay');
	selectElement.addEventListener('change', (event) => {
		const selectedValue = event.target.value;

		const urlParams = new URLSearchParams(window.location.search);
		urlParams.set('sort_by', selectedValue);
		const newUrl = window.location.pathname + '?' + urlParams.toString();
		window.history.pushState({}, '', newUrl);

		window.location.href = newUrl;
	});

	const tagFilter = document.querySelector('#tags-filter');
	tagFilter.addEventListener('change', (event) => {
		const selectedTag = event.target.value;

		window.location.href = 'https://carfume.co.uk/collections/all/' + selectedTag;
	});
}

// Search
const mainHeader = document.querySelector('#header').offsetHeight;
const topHeader = document.querySelector('.top-header').offsetHeight;
const searchBarHeight = mainHeader + topHeader;
document.querySelector('.search-header').style.height = searchBarHeight + 'px';

document.querySelector('.header__search').addEventListener('click', () => {
	document.body.classList.add('search-active');
});

if (document.querySelector('.template-search')) {
	document.querySelector('.search-again').addEventListener('click', () => {
		document.body.classList.add('search-active');
	});
}

document.querySelector('.close-search').addEventListener('click', () => {
	document.body.classList.remove('search-active');
});

if (document.querySelector('.accordian')) {
	const accordions = document.querySelectorAll('.accordion__question');
	accordions.forEach((accordion) => {
		accordion.addEventListener('click', (event) => {
			event.currentTarget.parentElement.classList.toggle('accordion__active');
			var accordionNext = event.currentTarget.nextElementSibling;
			if (accordionNext.style.maxHeight) {
				accordionNext.style.maxHeight = null;
			} else {
				accordionNext.style.maxHeight = accordionNext.scrollHeight + 'px';
			}
		});
	});
}

if (document.querySelector('.main-product__grid')) {
	var galleryThumbs = new Swiper('.gallery-thumbs', {
		spaceBetween: 10,
		slidesPerView: 4,
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});

	var galleryTop = new Swiper('.gallery-slider', {
		spaceBetween: 10,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		thumbs: {
			swiper: galleryThumbs,
		},
		on: {
			slideChange: function () {
				// Pause all videos first
				document.querySelectorAll('.gallery-slider video').forEach(video => {
					video.pause();
					video.currentTime = 0; // reset if you want
				});

				// Play only active slide's video
				let activeSlide = this.slides[this.activeIndex];
				let video = activeSlide.querySelector('video');
				if (video) {
					video.play();
				}
			}
		}
	});

	// Autoplay first video if first slide is video
	let firstVideo = document.querySelector('.gallery-slider .swiper-slide-active video');
	if (firstVideo) {
		firstVideo.play();
	}
}

